import { State } from "./state";
import { GetterTree } from "vuex";

import { getError, getDataList, getIsLoading, getDataItem, getSuccess } from "@/store/Crud/functions/getters";

function getYtLink(state: State): any {
  return state.youtubeLink;
}

export default <GetterTree<State, any>>{
  getDataList,
  getIsLoading,
  getSuccess,
  getError,
  getDataItem,
  getYtLink,
};
